import { ApiRequestDTO, ApiTraceDTO, FusionSummaryDTO, FusionSummaryProcessPriceDTO, FusionSummaryPerformanceDTO, FusionSummaryProcessTradeDetailDTO, FusionSummaryProcessTradeDTO, FusionSummaryTotalDTO, PreviewSummaryReportDTO, PreviewSummaryReportRowDTO } from "./DTO"
import { ApiRequest, ApiTrace, FusionSummary, FusionSummaryProcessPrice, FusionSummaryPerformance, FusionSummaryProcessTrade, FusionSummaryProcessTradeDetail, FusionSummaryTotal, PreviewSummaryReport, PreviewSummaryReportRow } from "../../../@type/api/api"

export const mapperApiTraceDTOToModel = (a: ApiTraceDTO): ApiTrace => ({
    Result: a.r,
    SeqRun: a.y,
    Product: a.w,
    RequestID: a.i,
    ProcessID: a.p,
    Environment: a.e,
    ClientID: a.c,
    ClientIP: a.x,
    Start: a.d,
    End: a.s,
    Elapsed: a.z,
    Action: a.a,
    Account: a.v,
    IsCorrectLog: a.l,
    TRDate: a.t
});

export const mapperApiRequestDTOToModel = (a: ApiRequestDTO): ApiRequest => ({
    id: a.a,
    RequestDate: a.b,
    RequestID: a.c,
    ProcessID: a.d,
    IsSuccess: a.e,
    Result: a.e ? 'Ok' : 'Error',
    Environment: a.f,
    Type: a.g,
    ClientId: a.h,
    ClientIP: a.i,
    Request: a.j,
    Message: a.k,
    SubAccount: a.l,
    Action: a.m,
    RequestJson: a.n,
    ResponseJson: a.o,
    Product: a.p,
    Metrics: a.q,
    SeqRun: a.r,
    TradeRateDate: a.s,
    ExceptionJson: a.t
});

export const mapperFusionSummaryDTOToModel = (d: FusionSummaryDTO): FusionSummary => ({
    TotalProcessTrades: mapperFusionSummaryTotalDTOToModel(d.tt),
    ProcessTrades: d.t.map(mapperFusionSummaryProcessTradeDTOToModel),
    TotalProcessPrices: mapperFusionSummaryTotalDTOToModel(d.tp),
    ProcessPrices: d.p.map(mapperFusionSummaryProcessPriceDTOToModel),
    ProcessPricePerformances: d.pp.map(mapperFusionSummaryPerformanceDTOToModel)
});


const mapperFusionSummaryProcessTradeDTOToModel = (d: FusionSummaryProcessTradeDTO): FusionSummaryProcessTrade => ({
    Status: d.s,
    ProcessID: d.p,
    Start: d.i,
    Account: d.a,
    Elapsed: d.e,
    Environment: d.v,
    Detail: d.d.map(mapperFusionSummaryProcessTradeDetailDTOToModel),
    TotalProcessTrade: mapperFusionSummaryTotalDTOToModel(d.tp)
});

const mapperFusionSummaryProcessTradeDetailDTOToModel = (d: FusionSummaryProcessTradeDetailDTO): FusionSummaryProcessTradeDetail => ({
    ProcessID: d.a,
    Account: d.b,
    RequestID: d.c, 
    RequestType: d.d, 
    Action: d.e, 
    Status: d.f, 
    TradesHeader: d.g, 
    Trades: d.h, 
    TradeRateDate: d.i, 
    Elapsed: d.j,
    Exceptions: d.k, 
    Message: d.l, 
    RequestFromFusion: d.m, 
    ResponseToFusion: d.n,
    ExceptionJson: d.o, 
    RequestToFusion: d.p, 
    ResponseFromFusion: d.q,
    StartRequest: d.r,
    EndRequest: d.s
});

const mapperFusionSummaryProcessPriceDTOToModel = (d: FusionSummaryProcessPriceDTO): FusionSummaryProcessPrice => ({
    ProcessID: d.a,
    RequestID: d.b,   
    RequestType: d.c,   
    Action: d.d,   
    Status: d.e,   
    PricesRequest: d.f,       
    PricesResponse: d.g,           
    PricesNA: d.h,       
    TradeRateDate: d.i,       
    Elapsed: d.j,   
    Exceptions: d.k,   
    Message: d.l,   
    RequestFromFusion: d.m,   
    ResponseToFusion: d.n,       
    ExceptionJson: d.o,
    RequestToFusion: d.p,
    ResponseFromFusion: d.q,
    TradesHeader: d.r,
    StartRequest: d.s,
    EndRequest: d.t,
    Environment: d.u
});

const mapperFusionSummaryTotalDTOToModel = (t: FusionSummaryTotalDTO): FusionSummaryTotal => ({
    Total: t.t,
    Ok: t.o,
    Labels: t.c,
    Data: t.d?.map(e => ({
        name: e.n,
        data: e.d
    }))
});

const mapperFusionSummaryPerformanceDTOToModel = (p: FusionSummaryPerformanceDTO) : FusionSummaryPerformance => ({
    label: p.l,
    value: p.v
})

export const mapperPreviewSummaryReportDTOToModel = (d: PreviewSummaryReportDTO) : PreviewSummaryReport => ({
    eod: d.r,
    ReportData: d.d.map(mapperPreviewSummaryReportRowDTOToModel),
    Emails: d.e
});

const mapperPreviewSummaryReportRowDTOToModel = (d: PreviewSummaryReportRowDTO) : PreviewSummaryReportRow => ({
    eod: d.r,
    Broker: d.b,
    Account: d.a,
    Insert: d.i,
    Delete: d.d,
    Match: d.m,
    Exercise: d.e,
    Expire: d.ep,
    Delivery: d.dv
});